export const CEBIA_BRAND = 'Cebia AutoTracer';
